export default __webpack_public_path__ + "static/layout-anatomy-light-1d39ace28f8e5d579147d8ea0425630d.png";